import React, { useContext } from 'react';
import { ModalDispatchContext, ModalStateContext } from '../../contexts/ModalProvider';

import styles from './Modal.module.scss';

const Modal: React.FC = () => {
  const content = useContext(ModalStateContext);
  const setModal = useContext(ModalDispatchContext);
  if (content) {
    document.body.classList.add('modalOpened');
    return (
      <div className={styles.overlay} onClick={() => setModal(null)} role='button'>
        {content}
      </div>
    );
  }
  document.body.classList.remove('modalOpened');
  return null;
};

export default Modal;
